"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClubInvoiceDetailPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ClubInvoiceContext_1 = require("../../sections/club-invoice/context/ClubInvoiceContext");
const club_invoice_detail_1 = require("../../sections/club-invoice-detail");
const react_router_dom_1 = require("react-router-dom");
const ClubInvoiceDetailPage = () => {
    const { id } = (0, react_router_dom_1.useParams)();
    return ((0, jsx_runtime_1.jsx)(ClubInvoiceContext_1.ClubInvoiceProvider, { children: (0, jsx_runtime_1.jsx)(club_invoice_detail_1.ClubInvoiceDetailComponent, { id: id ?? '' }) }));
};
exports.ClubInvoiceDetailPage = ClubInvoiceDetailPage;
